export class TrashItem {
  constructor(name, targetBin, src, alt) {
    this.name = name;
    this.targetBin = targetBin;
    this.src = src;
    this.alt = alt;
  }
}
